<nav class="ts-sidebar-nav">
    <div class="ts-sidebar-logo">
        <a routerLink="/dashboard" routerLinkActive="active-link" class="ts-sidebar-logo-link">
            <img src="assets/public/images/mainlogo_lg.png" alt="Truth Shorts Logo" width="36" height="36" style="object-fit:contain" />
        </a>
    </div>

    <div class="ts-sidebar-items">
        <a routerLink="/dashboard" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
            </span>
            <span class="ts-nav-label">Home</span>
        </a>

        <a routerLink="/explore" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                </svg>
            </span>
            <span class="ts-nav-label">Explore</span>
        </a>

        <a routerLink="/notifications" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon ts-nav-icon-badge-wrap" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
            </span>
            <span class="ts-nav-label">Notifications</span>
        </a>

        <a routerLink="/notifications" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                </svg>
            </span>
            <span class="ts-nav-label">Messages</span>
        </a>

        <a [routerLink]="['/', Username]"
           routerLinkActive="active-link"
           [routerLinkActiveOptions]="{ exact: true }"
           class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                </svg>
            </span>
            <span class="ts-nav-label">Profile</span>
        </a>

        <a routerLink="/notifications" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
            </span>
            <span class="ts-nav-label">Dashboard Login</span>
        </a>

        <a routerLink="/notifications" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
            </span>
            <span class="ts-nav-label">Admin Dashboard</span>
        </a>

        <a routerLink="/notifications" routerLinkActive="active-link" class="ts-nav-item">
            <span class="ts-nav-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="1.5" />
                    <circle cx="12" cy="12" r="1.5" />
                    <circle cx="12" cy="19" r="1.5" />
                </svg>
            </span>
            <span class="ts-nav-label">More</span>
        </a>
    </div>

    <div class="ts-sidebar-compose">
        <button type="button" class="ts-compose-btn" (click)="openPostSubmitModal()" title="Post">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="ts-compose-ico-xl" aria-hidden="true">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            <span class="ts-compose-label">Post</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" class="ts-compose-ico-lg" aria-hidden="true">
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
        </button>
    </div>

    <div class="ts-sidebar-user" *ngIf="Username && UserID">
        <div class="ts-user-pill">
            <div class="ts-user-avatar">
                <img [src]="'api/content/logo?userID=' + UserID" alt="" />
            </div>
            <div class="ts-user-text">
                <p class="ts-user-name">{{ Username }}</p>
                <p class="ts-user-handle">&#64;{{ Username }}</p>
            </div>
            <span class="ts-user-more" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <circle cx="12" cy="5" r="1.5" />
                    <circle cx="12" cy="12" r="1.5" />
                    <circle cx="12" cy="19" r="1.5" />
                </svg>
            </span>
        </div>
    </div>
</nav>
